/**
 * HOC that prevents unauthorized entry to protected routes.
 */

/**
 * TODO: Revisit the types.
 */

import React from "react";
import { Redirect } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

type TProtectedRoute = ({
  children,
}: {
  children: React.PropsWithChildren<any> | React.FC<any>;
}) => React.PropsWithChildren<any> | React.FC<any>;

export const ProtectedRoute: TProtectedRoute = ({
  children,
}: {
  children: React.PropsWithChildren<any> | React.FC<any>;
}) => {
  const isLoggedIn = useAuth().isAuthenticated;
  return isLoggedIn && typeof children !== undefined
    ? children
    : ((<Redirect to="/" />) as React.ReactElement);
};
